/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AgentPropallyComment model module.
 * @module model/AgentPropallyComment
 * @version 1.0.0
 */
class AgentPropallyComment {
    /**
     * Constructs a new <code>AgentPropallyComment</code>.
     * プロパリーからのコメント（未設定のエージェントは null）
     * @alias module:model/AgentPropallyComment
     * @param comment {String} 
     */
    constructor(comment) { 
        
        AgentPropallyComment.initialize(this, comment);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, comment) { 
        obj['comment'] = comment;
    }

    /**
     * Constructs a <code>AgentPropallyComment</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentPropallyComment} obj Optional instance to populate.
     * @return {module:model/AgentPropallyComment} The populated <code>AgentPropallyComment</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentPropallyComment();

            if (data.hasOwnProperty('comment')) {
                obj['comment'] = ApiClient.convertToType(data['comment'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentPropallyComment</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentPropallyComment</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of AgentPropallyComment.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['comment'] && !(typeof data['comment'] === 'string' || data['comment'] instanceof String)) {
            throw new Error("Expected the field `comment` to be a primitive type in the JSON string but got " + data['comment']);
        }

        return true;
    }


}

AgentPropallyComment.RequiredProperties = ["comment"];

/**
 * @member {String} comment
 */
AgentPropallyComment.prototype['comment'] = undefined;






export default AgentPropallyComment;

